export function getTotalOfDetailedAccounting(detailedAccounting: { amount: { value: number } }[]): number {
  return detailedAccounting.reduce((total, item) => total + item.amount.value, 0);
}
